import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { Box } from '@cp/ds/src/components/box';
import { Breadcrumbs } from '@cp/ds/src/components/breadcrumbs';
import { Container } from '@cp/ds/src/components/container';
import { Grid } from '@cp/ds/src/components/grid';
import { Image } from '@youhelp-ru/ui';
import { StyledListItem } from '@cp/ds/src/components/styled/styledListItem';
import { StyledUnorderedList } from '@cp/ds/src/components/styled/styledUnorderedList';
import { Typography } from '@cp/ds/src/components/typography';
import React, { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { RouteConfigComponentProps } from 'react-router-config';
import { useConfig } from '@cp/shared/config';
import { RoutedLink as Link } from 'src/shared/ui/link';
import Header from 'src/widgets/header';
import { WriteToDirector } from 'src/widgets/support';
import ImgDirectorWebp from './assets/director.webp';

const WriteToDirectorPage: React.FC<RouteConfigComponentProps> = () => {
  const formRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();
  const config = useConfig();

  return (
    <Box>
      <Helmet>
        <title>Напишите директору компании - YouHelp.ru</title>
      </Helmet>

      <Header />

      <Container sx={{ pb: { xs: 4, md: 8 } }}>
        <Breadcrumbs
          LinkComponent={Link}
          items={[
            {
              path: '/',
              label: 'Главная',
            },
            {
              path: '',
              label: 'Контакты',
            },
          ]}
          sx={{ my: 2 }}
        />
        <Typography component="h2" sx={{ typography: { xs: 'h4', md: 'h2' }, m: 0, mb: { xs: 4, md: 7 } }}>
          Напишите директору
        </Typography>
        <Grid alignItems={{ xs: 'center', md: 'flex-start' }} columnSpacing={4.25} container direction={{ xs: 'column', md: 'row' }}>
          <Grid size={{ lg: 3, md: 4, xs: 12 }}>
            <Image
              alt="Титов А.В."
              src={ImgDirectorWebp}
              sx={{ width: 1, height: 'auto', borderRadius: `${theme.borderRadius.large}px` }}
            />
          </Grid>
          <Grid size={{ lg: 9, md: 8, xs: 12 }}>
            <Typography component="h4" sx={{ typography: 'body' }}>
              Титов Андрей Владимирович
            </Typography>
            <StyledUnorderedList sx={{ my: { xs: 2, md: 3.125 } }}>
              <StyledListItem>
                Моя почта:{' '}
                <Link external href={`mailto:${config.get('ADMIN_EMAIL')}`} underline={false}>
                  {config.get('ADMIN_EMAIL', '')}
                </Link>
              </StyledListItem>
            </StyledUnorderedList>
            <Typography component="p" sx={{ color: 'gray', my: { xs: 1.5, md: 2.75 } }}>
              Директор и основатель Юхелп (YouHelp).
            </Typography>
            <Typography component="p" sx={{ color: 'gray', mt: { xs: 4, md: 10 } }}>
              Также для связи со мной можете воспользоваться{' '}
              <Typography
                onClick={() =>
                  formRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                  })
                }
                sx={{ cursor: 'pointer', color: 'brand pink' }}
              >
                формой для отправки сообщений,
              </Typography>{' '}
              расположенной внизу страницы.
            </Typography>
          </Grid>
        </Grid>
      </Container>
      <WriteToDirector id="contact-director" />
    </Box>
  );
};

export default WriteToDirectorPage;
